import { Component, OnInit } from '@angular/core';
import { StreApperInfo } from 'src/app/models/streapper-info.model';
import { StreappEventsService } from 'src/app/services/streapp-events.service';

@Component({
    selector: 'app-streappers',
    templateUrl: './streappers.component.html',
    styleUrls: ['./streappers.component.scss'],
    standalone: false
})
export class StreappersComponent implements OnInit {
  loading: boolean = true;
  errorText: string;
  streappers: StreApperInfo[] = [];

  constructor(private readonly streappService: StreappEventsService) { }

  ngOnInit(): void {
    this.streappService.getStreAppers().then(streappers => {
      this.streappers = streappers;
      this.loading = false;
    });
  }

}
